import { AxiosResponse } from 'axios';
import { stringify } from 'qs';

import { authNetworkService, networkService } from '@project/services';

import {
  Guid,
  InvoicePrintTemplateDto,
  PaidInvoiceOffender,
  PaymentUrlDto,
  PortalInvoiceDetailDto,
  ServiceResult,
} from '@project/types';
import invoiceUrls from './invoice.url';

const getInvoice = (id: Guid) => {
  const url = invoiceUrls.getInvoiceUrl(id);
  return networkService
    .get(url)
    .then((s: AxiosResponse<ServiceResult<PortalInvoiceDetailDto>>) => s.data.data);
};

const createInvoicePaymentLink = (id: Guid, source: number) => {
  const url = invoiceUrls.getInvoicePaymentLinkUrl(id);
  return networkService
    .post(
      url,
      {
        source,
      },
      { timeout: 0 },
    )
    .then((s: AxiosResponse<ServiceResult<PaymentUrlDto>>) => s.data.data);
};

const createInvoicePrintTemplate = (id: Guid) => {
  const url = invoiceUrls.getInvoicePrintTemplateUrl(id);
  return networkService
    .post(url)
    .then((s: AxiosResponse<ServiceResult<InvoicePrintTemplateDto>>) => s.data.data);
};

export const getInvoiceTotalsContent = (
  fromDate?: string,
  toDate?: string,
): Promise<AxiosResponse<Blob>> => {
  const url = invoiceUrls.getInvoiceTotalsContentUrl();

  return authNetworkService.get(url, {
    responseType: 'blob',
    timeout: 0,
    headers: { Accept: 'application/csv' },
    params: {
      fromDate,
      toDate,
    },
    paramsSerializer: (params) => stringify(params, { allowDots: true }),
  });
};

const fetchIndividualPaidInvoices = (ids: string[] = []): Promise<PaidInvoiceOffender[]> => {
  const serializedParams: Record<string, any> = {};

  if (ids.length > 0) {
    serializedParams.Filter = ids;
  }

  return authNetworkService
    .get(invoiceUrls.getIndividualPaidInvoicesUrl(), {
      params: serializedParams,
      paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
    })
    .then(
      (apiResponse: AxiosResponse<ServiceResult<PaidInvoiceOffender[]>>) => apiResponse.data.data,
    )
    .catch((error) => Promise.reject(error));
};

export const getInvoicePdf = (invoiceId: string): Promise<AxiosResponse<Blob>> => {
  const url = invoiceUrls.downloadInvoicePdfUrl(invoiceId);

  return authNetworkService.get(url, { responseType: 'blob', timeout: 0 });
};

export default {
  getInvoice,
  getInvoicePdf,
  createInvoicePaymentLink,
  createInvoicePrintTemplate,
  getInvoiceTotalsContent,
  fetchIndividualPaidInvoices,
};
